import { useQuery } from "@tanstack/react-query";
import { UploadCloud } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fetchBulkLeadJobs } from "../lib/api";

export function BulkLeadJobsPanel() {
  const { t } = useTranslation(["admin", "common"]);
  const jobsQuery = useQuery({
    queryKey: ["bulk-lead-jobs"],
    queryFn: fetchBulkLeadJobs,
    refetchInterval: 5000
  });

  if (!jobsQuery.data?.length) {
    return null;
  }

  return (
    <section className="data-panel" aria-label={t("admin:bulk.title")}>
      <div className="panel-title">
        <h2>{t("admin:bulk.title")}</h2>
        <UploadCloud aria-hidden="true" size={19} />
      </div>
      <div className="bulk-list">
        {jobsQuery.data.map((job) => {
          const progress = job.totalRows > 0 ? Math.round((job.processedRows / job.totalRows) * 100) : 0;
          return (
            <article className="bulk-job" key={job.id}>
              <div>
                <strong>{t(`admin:bulk.types.${job.type}`)}</strong>
                <span>{job.id}</span>
              </div>
              <div className="bulk-progress" aria-label={`${progress}%`}>
                <span style={{ inlineSize: `${progress}%` }} />
              </div>
              <div className="bulk-meta">
                <span>{t(`admin:bulk.status.${job.status}`)}</span>
                <span>
                  {job.processedRows}/{job.totalRows}
                </span>
                {job.failedRows > 0 ? <span>{t("admin:bulk.failed", { count: job.failedRows })}</span> : null}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
